import { render, staticRenderFns } from "./PhoneContents.vue?vue&type=template&id=3fea5192&scoped=true&"
import script from "./PhoneContents.vue?vue&type=script&lang=ts&"
export * from "./PhoneContents.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneContents.vue?vue&type=style&index=0&id=3fea5192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fea5192",
  null
  
)

export default component.exports